const routesConfig = {
  home: '/',
  signin: '/signin',
  verifyEmailMessage: '/verify-email',
  enrolmentForm: '/enrolment',
  signout: '/signout',
  signup: '/signup',
  signUpStudent: '/course/invite/:token',
  resetPassword: '/reset-password',
  resetPasswordVerify: '/reset-password/:token',
  emailVerification: '/email-verification/:token',
  onboardingTeacher: '/onboarding-teacher',
  onboardingStudent: '/onboarding-student',
  course: '/class',
  profile: '/profile',
  profileDetails: '/profile/course/:courseId',
  diningRoom: '/profile/dining-room',
  viewClass: '/view-class/:course_id',
  lessonHistory: '/view-class/:course_id/history',
  lessonDetails: '/view-class/:course_id/history/:lessonId',
  lessonDetailsReview: '/view-class/:course_id/history/:lessonId/review',
  lessonDetailsRecording: '/view-class/:course_id/history/:lessonId/recording',
  lessonDetailsTeacherFeedback:
    '/view-class/:course_id/history/:lessonId/teacher-feedback',
  viewClassStudent: '/course/:courseId/student/:studentId',
  courseMaterial: '/view-class/:course_id/material',
  calendar: '/calendar',
  quiz: '/quiz',
  folder: '/quiz/folder/:id',
  quizEdit: '/quiz/edit/:id',
  meeting: '/class/:courseId/start',
  homework: '/homework',
  homeworkAssign: '/homework/assign',
  homeworkDetails: '/homework/:assignmentId',
  homeworkEdit: '/homework/:assignmentId/edit',
  submissionDetails: '/homework/:assignmentId/submission/:submissionId',
  homeworkEditSubmission:
    '/homework/:assignmentId/submission/:submissionId/edit',
  branding: '/branding',
  test: '/test',
  termsAndConditions: '/terms',
  funclassHomepage:
    'https://www.getfunclass.com/funclass-pricing-771306',
  bbbRedirect: '/bbb-redirect',
  adminStudentsDashboard: '/students',
  adminCoursesDashboard: '/courses',
  adminAddCourse: '/course/add',
  adminStudentProfile: '/student/:studentId',
  adminCourseDetails: '/course/:courseId',
  adminEditCourse: '/course/:courseId/edit',
  adminTeachersDashboard: '/teachers',
  adminTeacherProfile: '/teacher/:teacherId',
  myCalendar: '/my-calendar',
  availability: '/my-calendar/availability',
  adminLessonHistory: '/history',
  adminLessonDetails: '/course/:courseId/lesson/:lessonId',
  adminCourseMaterial: '/course/:courseId/material',
  account: '/account',
  accountPolicy: '/account/policy',
  accountEdit: '/account/edit',
  accountUsage: '/account/usage',
  adminStudentPayments: '/payments',
  adminTeacherPayroll: '/teacher-payroll',
  adminTeacherPayrollDetails: '/teacher-payroll/:teacherId',
  notFound: '/404',
  petSelection: '/pet-selection',
  redirectPayment: '/redirect-payment/:paymentId',
  redirectSubscription: '/redirect-subscription/:paymentPlanId',
  accountPaymentSetup: '/account/payment-setup',
  accountStripeDetails: '/account/stripe-details',
  stripeOnboardingReturn: '/stripe-onboarding/return',
  petShop: '/shop',
  zoomLoginPage: '/zoom-login',
  zoomSetUp: '/zoom-setup',
  paymentSuccess: '/payment-success/:paymentPlanId',
  subscriptionSuccess: '/subscription-onboarding/:paymentPlanId',
  courseLeaderboard: '/course/:courseId/leaderboard',
};

export default routesConfig;
